// getDecimalFactorByCurrency.js
'use strict';
import { InternalCurrency } from '../resource/shopConstants.js';

/**
 * Get decimal factor by currency
 * @param {string} currency - target currency.
 * @return {number} decimal factor to devide with
 */
const getDecimalFactorByCurrency = ({ currency }) => {
  // TODO: ISO 4217
  const decimalFactor = ['JPY', InternalCurrency.DIAMONDS].includes(
    currency?.toUpperCase()
  )
    ? 1
    : 100;
  return decimalFactor;
};

export default getDecimalFactorByCurrency;
